export default __webpack_public_path__ + "static/media/mathClub.b732e780.png";